<template>
    <div class="container_1">

        <div class="left_box">
            <div @click="handle_detail(item)" v-for="item, index in tableData" :key="index"
                :style="cli == item.ID ? 'color:#c31424;' : ''" class="item">
                {{ item.TITLE }}
                <div v-if="item.ID == cli" class="left_shu_xian">

                </div>
            </div>
        </div>

        <!-- <div v-html="content_text" class="content_text">
        </div> -->

        <!-- <el-collapse accordion v-model="activeNames" @change="handleChange">
            <el-collapse-item @click="handle_detail(item)" v-for="item, index in tableData" :key="index"
                :name="item.ID">
                <template slot="title">
                    <div style="font-weight: 600;font-size: 20px;">
                        {{ item.TITLE }}<i style="margin-left: 8px;" class="header-icon el-icon-info"></i>
                    </div>
                </template>
<div v-html="content_text"></div>
</el-collapse-item>

</el-collapse>
<Loading :loading="loading" color="#c31424" background="rgba(0, 0, 0, 0)" /> -->
    </div>
</template>

<script>
export default {
    components: {},
    name: '',
    mixins: [],
    props: {},
    data() {
        return {
            cli: '',
            tableData: [],
            activeNames: '',
            content_text: '',
            loading: false,

        }
    },
    methods: {
        handleChange(e) {
            console.log(e, '---eee-->');
            if (e) {
                this.get_detail(e)
            } else {
                this.content_text = ''; // 更新表格数据

            }
        },
        handle_detail(e) {
            this.cli = e.ID
            this.get_detail(e.ID)

        },
        async get_list() {
            const res = await this.$http.get('/api/article/get_lists');
            console.log(res, 'resssssssss----->');
            if (res.data.code == 200) {
                this.tableData = res.data.data.data; // 更新表格数据
                this.cli = this.tableData[0].ID
                this.get_detail(this.cli)

                // this.query.page = res.data.data.current_page; // 后端返回了当前页，可以用于校准，但通常由前端维护current_change更新
            } else {
                this.$message.error(res.data.msg); // 显示错误信息
            }
        },
        async get_detail(e) {
            this.loading = true; // 开始加载，显示loading状态
            const res = await this.$http.get('/api/article/get_info', {
                params: {
                    id: e
                }
            });
            if (res.data.code == 200) {
                this.content_text = res.data.data.CONTENT; // 更新表格数据
                this.loading = false; // 开始加载，显示loading状态
                if (res.data.data.READ_FILE != '') {
                    console.log(res, 'resssssssss----->');
                    window.open(res.data.data.READ_FILE, '_blank', 'noopener,noreferrer');
                }

                // this.query.page = res.data.data.current_page; // 后端返回了当前页，可以用于校准，但通常由前端维护current_change更新
            } else {
                this.$message.error(res.data.msg); // 显示错误信息
            }
        }
    },
    created() {
        this.get_list()
    },
    mounted() { },
    computed: {},
    watch: {},
}
</script>

<style scoped lang="scss">
// 变量定义
$primary-color: #c31424;
$border-color: #eee;
$text-color: #666;
$bg-color: #f5f5f5;
$container-width: 1200px;

.container_1 {
    width: $container-width;
    padding-top: 35px;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
    display: flex;

    .left_box {
        width: 280px;
        background-color: #f8f8f8;
        border-radius: 3px;
        display: flex;
        flex-direction: column;
        height: fit-content;

        .item {
            width: 100%;
            height: 55px;
            text-align: center;
            line-height: 55px;
            position: relative;
            cursor: pointer;

            .left_shu_xian {
                position: absolute;
                left: 0;
                top: 0;
                height: 55px;
                width: 4px;
                border-radius: 60px 0 0 60px;
                background-color: #c31424;
            }
        }
    }

    .content_text {
        flex: 1;
        padding: 0 30px 0 30px;
    }
}
</style>